// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./toaster.types.d.ts" />
import { type JSX, type ReactNode, useMemo } from "react";

import { createToaster, Toaster as ArkToaster } from "@ark-ui/react/toast";

import { Flash } from "./Flash";
import { Snack } from "./Snack";
import { Toast } from "./Toast";
import { ToasterContext, type ToasterContextType } from "./context";
import { createFlashApi } from "./flash.api";
import { createSnackApi } from "./snack.api";
import { createToastApi } from "./toast.api";

type ToasterProps = {
  children?: ReactNode | ((ctx: ToasterContextType) => JSX.Element);
};

export function Toaster({ children }: ToasterProps): JSX.Element {
  const toast = createToaster({
    placement: "top-end",
    duration: 5000,
    removeDelay: 200,
  });

  const snack = createToaster({
    placement: "bottom-end",
    duration: 5000,
    removeDelay: 200,
    offsets: {
      top: "none",
      left: "none",
      right: "12px",
      bottom: "70px",
    },
  });

  const value = useMemo<ToasterContextType>(
    () => ({
      toast: createToastApi(toast),
      flash: createFlashApi(toast),
      snack: createSnackApi(snack),
    }),
    [toast, snack],
  );

  return (
    <ToasterContext.Provider value={value}>
      <ArkToaster toaster={toast}>
        {(toast) =>
          toast.meta?.variant === "flash" ? (
            <Flash {...toast} />
          ) : (
            <Toast {...toast} />
          )
        }
      </ArkToaster>
      <ArkToaster toaster={snack}>{(snack) => <Snack {...snack} />}</ArkToaster>
      {typeof children === "function" ? children(value) : children}
    </ToasterContext.Provider>
  );
}
